import  { createContext,useEffect,useContext, useState } from "react";
import { supabase } from "../supabaseClient";
const AuthContext = createContext();



export const AuthContextProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [session, setSession] = useState(null);
    const [userFromAuth, setAuthUser] = useState(null);



  const signUpNewUser= async ({email,password})=>{

    const {data,error} = await supabase.auth.signUp({
        email:email,
        password:password
    })

    if(error){
        console.log("there was an error signing up",error);
        return {success:false,error}
    }

    return {success:true,data}
  }

  async function getUser() {
  const { data: { user }, error } = await supabase?.auth.getUser();

  if (error) {
    console.error("Error fetching user:", error);
    return null;
  }

  return user; // ✅ Return the user so components can use it
}

useEffect(() => {
  // Get the current session
  supabase.auth.getSession().then(({ data: { session } }) => {
    setSession(session);
  });

  // Listen for changes to the auth state
  const { data: listener } = supabase.auth.onAuthStateChange((_event, session) => {
    setSession(session);
  });

  // Cleanup: unsubscribe when the component unmounts
  return () => {
    listener?.subscription?.unsubscribe();
  };
}, []);


  const signOut = ()=>{
    const {error} = supabase.auth.signOut()

    if(error){
        console.error("there were error sign out",error)
    }
  }

  const signUser= async ({email,password})=> {

    try{
        const {data,error} = supabase.auth.signInWithPassword({
            email:email,
            password:password
        })

        if(error){
            console.error('sign in error',error)
            return  {success:false, error:error.message}
        }

        console.log("sign in success", data)
        return {success:true,data}

    }catch(error){
        console.error('an error signin',error);
    }
  }

  


  useEffect(() => {
    const fetchUser = async () => {
        const { data: { user } } = await supabase.auth.getUser()
  

  setAuthUser(user)
    };
    fetchUser();
  }, []);

  return (
    <AuthContext.Provider value={{ getUser,userFromAuth,session ,signUpNewUser,signOut,signUser}}>
      {children}
    </AuthContext.Provider>
  );
}


export const UserAuth = () => useContext(AuthContext);
